import { useState } from 'react';
import ChangePassword from './ChangePassword';
import CommonDialog from '../../../components/common/CommonDialog';
import { UserRoundPen } from 'lucide-react';
import { CSS_PRIMARY } from '../../../../constants/style';

function PasswordChange() {
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <>
      <button type="button" className="dropdown-item ai-icon" onClick={() => setOpenDialog(true)}>
        <UserRoundPen size={18} color={CSS_PRIMARY} />
        <span className="ms-2">Change Password</span>
      </button>

      <CommonDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        title="Change Password"
        maxWidth="xs"
        fullWidth
      >
        <ChangePassword onClose={() => setOpenDialog(false)} />
      </CommonDialog>
    </>
  );
}

export default PasswordChange;
